/* KifTech cart drawer recommendations.
   <kt-cart-recs> (snippets/kt-cart-recs.liquid) loads sections/kt-cart-recs.liquid through
   Shopify's product recommendations endpoint for the item most recently added to the cart.
   Tries complementary products first (Search & Discovery app), then related products.
   "Add" puts single-variant products straight into the cart and refreshes the drawer;
   products with options link to their product page. */
(function () {
  if (customElements.get('kt-cart-recs')) return;
  var cache = {};

  function fetchItems(base, productId, limit, intent) {
    var url = base + '?product_id=' + encodeURIComponent(productId) + '&limit=' + limit +
      '&section_id=kt-cart-recs&intent=' + intent;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('[data-kt-crecs-items]');
        return items && items.querySelector('.kt-crecs__item') ? items.innerHTML : null;
      })
      .catch(function () { return null; });
  }

  class KtCartRecs extends HTMLElement {
    connectedCallback() {
      var self = this;
      var base = this.dataset.url;
      var id = this.dataset.productId;
      var limit = this.dataset.limit || 6;
      var intent = this.dataset.intent || 'related';
      if (!base || !id) return;
      var total = document.querySelector('.totals__total-value');
      var key = [id, limit, intent, total ? total.textContent.trim() : ''].join('|');
      this.mount = this.querySelector('[data-kt-crecs-mount]');
      this.error = this.querySelector('[data-kt-crecs-error]');
      this.addEventListener('click', this.onClick.bind(this));
      if (cache[key]) { this.show(cache[key]); }
      var first = fetchItems(base, id, limit, intent);
      var chain = intent === 'complementary'
        ? first.then(function (h) { return h || fetchItems(base, id, limit, 'related'); })
        : first;
      chain.then(function (html) {
        if (!self.isConnected) return;
        if (html) { cache[key] = html; self.show(html); } else if (!cache[key]) { self.hidden = true; }
      });
    }

    show(html) {
      this.mount.innerHTML = html;
      this.hidden = false;
    }

    onClick(event) {
      var btn = event.target.closest('[data-kt-crecs-add]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      var self = this;
      var label = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = '…';
      if (this.error) this.error.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.ktCrecsAdd), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add this item.');
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.json.sections) {
            drawer.renderContents(res.json);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kt-cart-recs', cartData: res.json });
          }
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
          if (self.error) { self.error.textContent = err.message; self.error.hidden = false; }
        });
    }
  }

  customElements.define('kt-cart-recs', KtCartRecs);
})();
